module.exports = __webpack_public_path__ + "static/media/rotatephone.c3764297.gif";